import React from "react";
import { MobileResponsive } from "./MobileResponsive";
import Sidebar from "../components/Sidebar";
import useDataFetch from "../hooks/useDataFetch";
import DynamicMetaTags from "../components/DynamicMetaTags";

const Profile = () => {
  const { data, isLoading } = useDataFetch(`/admin/profile`);

  if (isLoading) {
    return (
      <>
        <MobileResponsive />
        <div className="lg:flex hidden items-start">
          <Sidebar />
          <div className="ml-[14.5vw] w-full h-screen flex items-center justify-center bg-gray-50">
            <div className="flex flex-col items-center gap-2">
              <div className="h-12 w-12 rounded-full border-4 border-t-quaternary border-b-quaternary border-r-transparent border-l-transparent animate-spin"></div>
              <p className="text-gray-600 font-medium">Loading..</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <DynamicMetaTags
        pageTitle="Beep - Your Profile at a Glance"
        pageDescription="Get real-time insights with Beep's dashboard! Monitor active drivers, food outlets, hubs, and detailed analytics on orders. Track Pending, Delivering, and Done orders seamlessly across outlets and hubs."
        pageKeywords="Beep, logistics dashboard, real-time analytics, active drivers, active food outlets, active hubs, order tracking, pending orders, delivering orders, completed orders, logistics insights"
      />
      <MobileResponsive />
      <div className="lg:flex hidden items-start">
        <Sidebar />

        <div className="ml-[14.5vw] w-full h-screen overflow-y-auto px-10 py-8 text-secondary relative">
          <div className="flex w-full">
            <button disabled className="flex items-center gap-3">
              {/* <div className="bg-[#F75E00] w-5 h-5 flex items-center justify-center rounded-full pr-[1.5px]">
                <img
                  src="/assets/left-white-arrow.svg"
                  alt=""
                  className="w-[6px]"
                />
              </div> */}
              <span className="font-semibold text-[20px]">Profile</span>
            </button>
          </div>

          <div className="w-full flex items-start py-10">
            <div className="2xl:w-[38%] xl:w-[50%] lg:w-[50%]">
              {isLoading ? (
                "Loading.."
              ) : (
                <div className="border-2 border-quaternary w-[84.5%] px-5 py-1.5 rounded-lg flex flex-col items-center justify-between bg-[#F7F9F8]">
                  {[
                    { label: "Name", value: data?.name },
                    {
                      label: "Email",
                      value: data?.email,
                    },
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center w-full py-2">
                      <p className="text-[15px] font-semibold tracking-wide w-[30%] break-all">
                        {item.label}
                      </p>
                      <p
                        className={`text-[15px] font-semibold tracking-wide w-[70%] break-all ${
                          item.label === "Name" && "capitalize"
                        }`}
                      >
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
